import { VisuallyHidden as VisuallyHiddenPrimitive } from 'radix-ui';
export const VisuallyHidden = VisuallyHiddenPrimitive.Root;
export const Root = VisuallyHiddenPrimitive.Root;
export type VisuallyHiddenProps = VisuallyHiddenPrimitive.VisuallyHiddenProps;
